import React from "react";
import { Text } from "@commonsku/design-system";

export interface PersonLinkProps {
  userId: string;
  children?: React.ReactNode;
}

/** A person's name, styled as a link that opens their profile in a new tab. */
const PersonLink = ({ userId, children }: PersonLinkProps) => (
  <Text
    as="span"
    colorPalette="brand"
    color="colorPalette.fg"
    cursor="pointer"
    _hover={{ textDecoration: "underline" }}
    onClick={(e) => {
      // The row itself is a Link to the parent record; this needs its own
      // destination, so it can't be a nested <a>.
      e.preventDefault();
      e.stopPropagation();
      window.open(`/user.php?id=${userId}`, "_blank", "noopener,noreferrer");
    }}
  >
    {children}
  </Text>
);

export default PersonLink;
